export default function listrakEmptyCart() {
  try {
    // eslint-disable-next-line no-underscore-dangle
    window._ltk?.SCA?.ClearCart?.()
  } catch {
    // fail silently
  }
}
